module.exports = __webpack_public_path__ + "static/media/caret-right.04323611.svg";